import { IApplicationState } from '../../types/redux';

export const selectIsRegistered = (state: IApplicationState) => state.legalCheck.isRegistered;
